import {
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY,
} from '@atlassian/jira-common-constants/src/project-template-type-keys';

export const PACKAGE_NAME = 'jiraServicedeskGettingStartedPage';
export const PACKAGE_TEAM_NAME = 'itops-mithril';
export const JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED =
	'servicedesk-getting-started-page-request-channels-customised';
export const JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED =
	'servicedesk-getting-started-page-request-types-reviewed';
export const JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED =
	'servicedesk-getting-started-page-queue-customised';

export const JSM_GETTING_STARTED_PAGE_ADD_TEAMMATES =
	'servicedesk-getting-started-page-invite-team';
export const JSM_GETTING_STARTED_PAGE_NAME = 'servicedesk-getting-started-page';

export const IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management';
export const NEW_IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management-advanced';
export const REFERRER = 'referrer';

export const ERROR_CODE_NOT_FOUND = 404;

export const CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact/#/';
export const JSM_DOCUMENTATION_URL =
	'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
export const ASK_COMMUNITY_URL =
	'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';

export const SAMPLE_SPACE_URL = '/jira/servicedesk/itsm-sample-space';

export const UNKNOWN_PROJECT_TEMPLATE_KEY = '';

export const GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD = [
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM = [
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const JSM_EXCLUDED_TEMPLATES_FOR_NPLE = [
	IT_SERVICE_MANAGEMENT_KEY,
	NEW_IT_SERVICE_MANAGEMENT_KEY,
	IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY,
	IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const REQUEST_CHANNEL_PORTAL = 'Portal';
export const REQUEST_CHANNEL_CHAT = 'Chat';
export const REQUEST_CHANNEL_EMAIL = 'Email';
export const REQUEST_TYPES_MAX_ELEMENTS = 4;

export const ManageQueuesArticleId = '5b7BuVaVJqmbyCZ2mbMYHD';
export const InviteTeamArticleId = '3cdZ1Fc5T12gySP1kroJJr';
export const RequestChannelsArticleId = '3v4bqtuzeA4dOJq6A4yhiM';
export const RequestTypesArticleId = 'eYQImfQnsXgIvrECKaQTF';
export const ViewIssueArticleId = '102lbF25oEeqn7GG1rXPUA';
export const LearnAboutProjectRolesArticleId = '6aIMqm2F5KAhHo3BbFYp0p';

export const REQUEST_CHANNELS = 'RequestChannel';
export const REQUEST_TYPES = 'RequestTypes';
export const INVITE_TEAM = 'InviteTeam';
export const MANAGE_QUEUES = 'ManageQueues';
export const INVITE_PROJECT_ADMIN = 'InviteProjectAdmin';

// Analytics
export const NEW_LANDING_PAGE_EXPERIENCE_PROD = 'newLandingPageExperienceProd';
export const NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM = 'newLandingPageExperienceProdITSM';
export const NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_VARIATION =
	'newLandingPageExperienceInviteTeamMemberExperimentVariation';
export const NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_CONTROL =
	'newLandingPageExperienceInviteTeamMemberExperimentControl';
// Promise
export const PROMISE_REJECTED = 'rejected';

export const DEMO_ISSUE_LABEL = 'onboarding-learn-by-doing-demo-issue';
export const DEMO_ISSUE_ERROR_FLAG_ID = 'onboarding-sample-issue-error';

export const DISABLE_NPLE_PROJECT_PROJECT_KEY = 'npleDisabled';
export const DISABLE_NPLE_ERROR_FLAG_ID = 'disable-nple-error';
export const DISABLE_NPLE_SUCCESS_FLAG_ID = 'disable-nple-success';

export const INCIDENTS = 'incidents';
export const CHANGES = 'changes';
export const ALERTS = 'alerts';
